import { IDrawOverlays, IOverlayDelete, IResult } from "@/types/map";
import { Point, LineString, Polygon } from 'ol/geom';
import { Draw, Modify, Snap } from 'ol/interaction';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { RegularShape, Fill, Stroke, Style, Icon, IconImage, Text, Circle as CircleStyle } from 'ol/style';
import { Collection } from "ol";
import EsriJSON from 'ol/format/EsriJSON.js';



export class DrawOverlaysOpenlayers  {
    private static instances: Map<string, any>;
    private map!: any;
    private drawlayer!: any;
    private drawSource!: any;
    private draw!: any;
    private snap!: any;
    private featureArr!: any;

    private constructor(map: any) {
        this.map = map;
    };
    public static getInstance(map: any){
        let id = map.getTarget();
        // console.log(id);
        if (!DrawOverlaysOpenlayers.instances) {
            DrawOverlaysOpenlayers.instances = new Map();
        }
        let intance = DrawOverlaysOpenlayers.instances.get(id);
        if (!intance) {
          intance = new DrawOverlaysOpenlayers(map);
          DrawOverlaysOpenlayers.instances.set(id, intance);
        }
        return intance;
    };
    public static destroy() {
      (DrawOverlaysOpenlayers.instances as any) = null;
    };
    public clear() {
      if (this.drawlayer) {
        // this.drawlayer.setSource();
        this.map.removeLayer(this.drawlayer);
        this.drawSource = "";
      }
    };
    // 停止绘制
    public stopDrawOverlays() {
        this.draw.setActive(false);
        // if (this.draw){
        //     this.map.removeInteraction(this.draw);
        // };
        // if (this.snap){
        //     this.map.removeInteraction(this.snap);
        // };
    };
    // 创建绘制图层
    private async createOverlaysLayer() {
      let layer = this.map.getAllLayers().find((layer: any) => {
        return layer.get("label") === 'drawOverlays';
      });
      if (!layer) {
        console.log("创建图层");
        layer = new VectorLayer();
        (layer as any).set("label", "drawOverlays");
        let index = (this.map as any).get("mapConfig").customLayers?.length || 0;
        layer.setZIndex(index);
        this.map.addLayer(layer);
      };
      return layer;
    };
    // 画点、画线、画多边形
    public async startDrawOverlays(params: IDrawOverlays): IPromise<void> {
        // this.map.getAllLayers().forEach((e: any) =>{
        //     if (e.get("label") == "上海市支队区域服务"){
        //         console.log(e);
        //         console.log(e.getSource());
        //         console.log(e.getSource().getUrl());
        //         // console.log(e.getSource().getParams().LAYERS);
        //         // console.log(e.getSource().getParams().LAYERS.split(":")[1]);
        //         // console.log(e.getSource().getFeatures());
        //         // let imageArcGISRestUrl = "http://128.64.151.195:6080/arcgis/rest/services/Edpass/shanghai_base_area/MapServer"
        //         // let imageArcGISRestUrl = "http://128.64.151.195:6080/arcgis/rest/services/Edpass/shanghai_base_area/MapServer/0?f=pjson"
        //         // fetch(imageArcGISRestUrl).then(response => {
        //         //     console.log(111);
        //         //     console.log(response);
        //         //     // console.log(response.json());
        //         //     if (response.ok) {
        //         //         return response.json();
        //         //     }
        //         //     throw new Error('Network response was not ok.');
        //         // }).then(data => {
        //         //     console.log(222);
        //         //     console.log(data);
        //         //     console.log(data.layers); // 打印要素数据 // 在这里处理获取的要素数据
        //         // }).catch(error => {
        //         //     console.error('There was a problem fetching the data:', error);
        //         // });

        //         // let imageArcGISRestUrl = "http://128.64.151.195:6080/arcgis/rest/services/Edpass/shanghai_base_area/MapServer/0/query?where=ZD_CODE%3D%27311500000000%27&f=json"
        //                                     "http://128.64.151.195:6080/arcgis/rest/services/Edpass/shanghai_base_area/MapServer/0/query?where=ZD_CODE=311500000000&f=json"
        //         let url =  e.getSource().getUrl();
        //         let layerNum = e.getSource().getParams().LAYERS.split(":")[1];
        //         // let imageArcGISRestUrl = url + "/" + layerNum + "/query?where=" + "1" + "=" + "1" + "&f=json";//获取所有要素
        //         let imageArcGISRestUrl = url + "/" + layerNum + "/query?where=" + "ZD_CODE" + "=" + "'311500000000'" + "&f=json";//获取指定要素
        //         console.log(imageArcGISRestUrl);
        //         let ArcGISJSON;
        //         fetch(imageArcGISRestUrl).then(response => {
        //             console.log(response);
        //             // console.log(response.json());
        //             if (response.ok) {
        //                 return response.json();
        //             }
        //             throw new Error('Network response was not ok.');
        //         }).then(data => {
        //             console.log(data);
        //             console.log(data.features[0].geometry.rings);
        //             // ArcGISJSON = new EsriJSON(data);
        //             // console.log(ArcGISJSON);
        //             // console.log(data.layers); // 打印要素数据 // 在这里处理获取的要素数据
        //         }).catch(error => {
        //             console.error('There was a problem fetching the data:', error);
        //         });



        //     }
        // });



        // // console.log(this.map.getView());
        // // console.log(this.map.getView().getCenter());
        // // console.log(this.map.getView().getZoom());
        // // console.log(this.map.getView());
        this.drawlayer = await this.createOverlaysLayer();
        // console.log("开始绘制：");
        // console.log(params);
        let symbol: any = {};
        // 要素样式
        if (params.drawTypeOl == "Point"){//点
            symbol = {
                image: new CircleStyle({
                    radius: params.symbol.radius || 1,
                    fill: new Fill({
                        color: params.symbol.fill.color
                    }),
                    stroke: new Stroke({
                        color: params.symbol.stroke.color,
                        width: params.symbol.stroke.width,
                    })
                })
            };
        }else if (params.drawTypeOl == "LineString"){//线
            symbol = {
                stroke: new Stroke({
                    color: params.symbol.stroke.color,
                    width: params.symbol.stroke.width,
                })
            };
        }else if (params.drawTypeOl == "Polygon"){//面
            symbol = {
                fill: new Fill({
                    color: params.symbol.fill.color
                }),
                stroke: new Stroke({
                    color: params.symbol.stroke.color,
                    width: params.symbol.stroke.width,
                    // lineDash: params.symbol.stroke.lineDash
                })
            };
        };
        let featureStyle = new Style(symbol);
        console.log(this.drawlayer);
        this.drawlayer.setStyle(featureStyle);
        if (!this.drawSource){
            this.drawSource = new VectorSource();
            this.featureArr = new Collection();
            this.drawlayer.setSource(this.drawSource);
        };
        if (this.draw){
            this.map.removeInteraction(this.draw);
        };
        if (this.snap){
            this.map.removeInteraction(this.snap);
        };
        console.log(this.drawlayer.getSource());
        this.draw = new Draw({
            type: params.drawTypeOl,
            source: this.drawlayer.getSource(),       
            features: this.featureArr, 
            stopClick: true,
        });
        this.snap = new Snap({
            source: this.drawlayer.getSource(),
        });
        this.map.addInteraction(this.draw);
        this.map.addInteraction(this.snap);
        let repeat = params.repeat || false;
        if (repeat){
            this.draw.on('drawend',  () => {
                this.draw.setActive(false);// 当drawend事件触发时，停止监听draw事件，从而停止绘制
            });
        };
        
        // feature.setProperties({ fields: point.fields, markType: params.type, markId: point.id, symbol: point.symbol });
    };
    // 获取绘制结果、获取地图上所有绘制的覆盖物结果
    public async getDrawOverlays(): Promise<IResult> {   
        return new Promise((resolve: any, reject: any) => {
            let layer = this.map.getAllLayers().find((layer: any) => {
                return layer.get("label") === 'drawOverlays';
            });
            if (!layer) {
                resolve({ status: 0, message: '', result: {} });
            };
            let overlays: any[] = [];
            // this.drawlayer.getSource().getFeatures().forEach((e: {//方式一
            //     getStyle(): any;
            //     getKeys(): any;
            //     getProperties: () => any; 
            //     getGeometry: () => any; 
            // }) =>{
            //     overlays.push({
            //         type: e.getGeometry().getType(),
            //         id: e.getGeometry().ol_uid,
            //         geometry: e.getGeometry(),
            //     });
            // });
            this.featureArr.forEach((e: any) =>{//方式二
                overlays.push({
                    type: e.getGeometry().getType(),
                    id: e.getGeometry().ol_uid,
                    geometry: e.getGeometry(),
                });
            });
            let result = { type: 'drawOverlays', overlays: overlays };
            resolve({
                status: 0,
                message: '',
                result: { dataJson: JSON.stringify(result), data: result },
            });
        });
    };
    // 删除绘制结果
    public async deleteDrawOverlays(params: IOverlayDelete): Promise<void> {
        // 获取所有图层的集合
        let layer = this.map.getAllLayers().find((layer: any) => {
            return layer.get("label") == "上海市支队区域服务";
        });
        console.log(layer.getSource().getUrl(), 111);

        const features = layer.getSource().getFeatures();
        features.forEach((feature: any) => {
            console.log(feature.getProperties());
        });

        return new Promise((resolve: any, reject: any) => {
            let layer = this.map.getAllLayers().find((layer: any) => {
                return layer.get("label") === "drawOverlays";
            });
            if (!layer) {
                resolve({ status: 0, message: "", result: {} });
            }
            this.clear();

            resolve({ status: 0, message: "", result: {} });

            // if (params) {

            // } else {

            // }
        });
    };
}